<template>
  <BaseSelect
    v-model="modelValue"
    :options="computedOptions"
  >
    <template #button>
      <button
        type="button"
        class="flex w-full items-center justify-between rounded-full border border-background-fg/8 p-1 shadow-sm"
        :class="[
          modelValue
            ? 'bg-primary text-white'
            : 'bg-background',
          'disabled:opacity-70',
        ]"
        :disabled="isDisabled"
      >
        <span
          :class="[
            modelValue ? '' : 'text-background-fg/70',
            'mx-2 line-clamp-1 text-xs font-medium',
          ]"
        >
          <template v-if="selectedOption">
            {{ selectedOption.label }}
          </template>
          <template v-else>
            {{ props.label }}
          </template>
        </span>
        <IconChevronDown
          class="rounded-full bg-background-fg/10"
        />
      </button>
    </template>
  </BaseSelect>
</template>

<script
  setup
  lang="ts"
  generic="TValue extends string | number"
>
import type { Option } from "@/composables/options/options"

const props = defineProps<{
  options: Array<Option<TValue>>
  label: string
  isDisabled?: boolean
}>()

const modelValue = defineModel<TValue | undefined>({
  required: true,
})

const computedOptions = computed<
  Array<Option<TValue | undefined>>
>(() => [
  {
    value: undefined,
    label: "---",
  },
  ...props.options,
])

const selectedOption = computed(() =>
  props.options.find(
    ({ value }) => value === modelValue.value
  )
)
</script>
